import React from "react";
import { getDashboardCarouselPosition } from "../config/dashboardCarousel";
import { useIsDesktopViewport } from "../hooks/useIsDesktopViewport";
import "./DashboardPositionIndicator.css";

/**
 * Subtle two-face hint. Either chevron means the same destination.
 * Tap uses the same navigation as a horizontal swipe.
 */
export function HomeSwipeAffordance({ face = "home", onActivate }) {
  const isDesktop = useIsDesktopViewport();
  const onQuickCreate = face !== "quick_create";
  if (isDesktop && onQuickCreate) {
    return null;
  }
  const label = isDesktop
    ? "Return to Home"
    : onQuickCreate
      ? "Swipe left or right to open Quick Create"
      : "Swipe left or right to return Home";

  return (
    <button
      type="button"
      className="dashboard-position-indicator dashboard-position-indicator--inline"
      aria-label={label}
      onClick={onActivate}
    >
      <span aria-hidden="true">‹</span>
      <span className="dashboard-position-indicator-separator" aria-hidden="true">
        ·
      </span>
      {onQuickCreate ? "Quick Create" : "Home"}
      <span className="dashboard-position-indicator-separator" aria-hidden="true">
        ·
      </span>
      <span aria-hidden="true">›</span>
    </button>
  );
}

export function DashboardPositionIndicator({ currentScreen, onOpen }) {
  const position = getDashboardCarouselPosition(currentScreen);

  if (!position) {
    return null;
  }

  const { index, total, label } = position;

  return (
    <button
      type="button"
      className="dashboard-position-indicator"
      aria-label={`Dashboard ${index} of ${total}, ${label}. Open dashboard navigator.`}
      onClick={onOpen}
    >
      {index} of {total}
      <span className="dashboard-position-indicator-separator" aria-hidden="true">
        ·
      </span>
      {label}
    </button>
  );
}
